(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tabs-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-tabs')) {
    customElements.define(
      'product-tabs',
      class ProductTabs extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.links = Array.from(this.querySelectorAll('.product-tabs__link'));
          this.isSticky = false;
          this.isProgrammaticScroll = false;
          this.frame = null;
          this.scrollTimer = null;
          this.programmaticTimer = null;
          this.initialOffsetTop = this.getBoundingClientRect().top + window.scrollY;
          this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.handleScroll = this.handleScroll.bind(this);
          this.handleResize = this.handleResize.bind(this);
          this.handleClick = this.handleClick.bind(this);

          window.addEventListener('scroll', this.handleScroll, { passive: true });
          window.addEventListener('resize', this.handleResize, { passive: true });
          this.addEventListener('click', this.handleClick);

          this.updateStickyState();
          this.updateActiveTab();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.handleScroll);
          window.removeEventListener('resize', this.handleResize);
          this.removeEventListener('click', this.handleClick);
          window.clearTimeout(this.scrollTimer);
          window.clearTimeout(this.programmaticTimer);

          if (this.frame) window.cancelAnimationFrame(this.frame);

          this.getPlaceholder()?.remove();
          this.initialized = false;
        }

        get stickyTop() {
          return Number.parseFloat(window.getComputedStyle(this).getPropertyValue('--sticky-top')) || 0;
        }

        getPlaceholder() {
          const sibling = this.nextElementSibling;
          return sibling?.dataset.tabsPlaceholder === this.dataset.sectionId ? sibling : null;
        }

        setActiveTab(activeLink) {
          this.links.forEach((link) => {
            const isActive = link === activeLink;
            link.classList.toggle('is-active', isActive);

            if (isActive) {
              link.setAttribute('aria-current', 'true');
            } else {
              link.removeAttribute('aria-current');
            }
          });
        }

        updateStickyState() {
          const shouldStick = window.scrollY + this.stickyTop >= this.initialOffsetTop;

          if (shouldStick && !this.isSticky) {
            const placeholder = document.createElement('div');
            placeholder.dataset.tabsPlaceholder = this.dataset.sectionId;
            placeholder.style.height = `${this.offsetHeight}px`;
            this.insertAdjacentElement('afterend', placeholder);
            this.classList.add('is-sticky');
            this.isSticky = true;
          } else if (!shouldStick && this.isSticky) {
            this.classList.remove('is-sticky');
            this.getPlaceholder()?.remove();
            this.isSticky = false;
            this.initialOffsetTop = this.getBoundingClientRect().top + window.scrollY;
          }

          if (this.isSticky) {
            const placeholder = this.getPlaceholder();
            if (placeholder) placeholder.style.height = `${this.offsetHeight}px`;
          }
        }

        updateActiveTab() {
          if (this.isProgrammaticScroll) return;

          const threshold = this.stickyTop + (this.isSticky ? this.offsetHeight : 0) + 24;
          let activeLink = null;
          let shortestDistance = Number.POSITIVE_INFINITY;

          this.links.forEach((link) => {
            const target = document.getElementById(link.dataset.targetId);
            if (!target) return;

            const rect = target.getBoundingClientRect();
            if (rect.top < window.innerHeight && rect.bottom > threshold) {
              const distance = Math.abs(rect.top - threshold);
              if (distance < shortestDistance) {
                shortestDistance = distance;
                activeLink = link;
              }
            }
          });

          if (activeLink) this.setActiveTab(activeLink);
        }

        handleScroll() {
          if (this.frame) return;

          this.frame = window.requestAnimationFrame(() => {
            this.updateStickyState();
            this.updateActiveTab();
            this.frame = null;

            window.clearTimeout(this.scrollTimer);
            this.scrollTimer = window.setTimeout(() => {
              this.isProgrammaticScroll = false;
            }, 180);
          });
        }

        handleResize() {
          if (this.frame) window.cancelAnimationFrame(this.frame);

          this.frame = window.requestAnimationFrame(() => {
            const placeholder = this.getPlaceholder();
            if (placeholder) {
              this.initialOffsetTop = placeholder.getBoundingClientRect().top + window.scrollY;
            } else {
              this.initialOffsetTop = this.getBoundingClientRect().top + window.scrollY;
            }

            this.updateStickyState();
            this.frame = null;
          });
        }

        handleClick(event) {
          const link = event.target.closest('.product-tabs__link');
          if (!link || !this.contains(link)) return;

          const target = document.getElementById(link.dataset.targetId);
          if (!target) return;

          event.preventDefault();
          this.isProgrammaticScroll = true;
          this.setActiveTab(link);

          const top = Math.max(
            0,
            target.getBoundingClientRect().top + window.scrollY - this.offsetHeight - this.stickyTop - 20
          );

          window.history.pushState(null, '', link.getAttribute('href'));
          window.scrollTo({
            top,
            behavior: this.prefersReducedMotion.matches ? 'auto' : 'smooth'
          });

          window.clearTimeout(this.programmaticTimer);
          this.programmaticTimer = window.setTimeout(() => {
            this.isProgrammaticScroll = false;
          }, 1000);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
